export default __webpack_public_path__ + "static/media/med.f300d5a9.svg";